import { DatePipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { PlanoContratacaoAnualService } from "compra-lib";
import { BaseResourceRptComponent, Coluna, EddyAutoComplete, Login, Unidade, UnidadeService } from "eddydata-lib";
import { takeUntil } from "rxjs/operators";
import * as toastr from 'toastr';

@Component({
  selector: 'app-plano-contratacao-anual-comparativo-rpt',
  templateUrl: './plano-contratacao-anual-comparativo-rpt.component.html'
})
export class PlanoContratacaoAnualComparativoRptComponent extends BaseResourceRptComponent {

  // ========================================================================
  // ----------------------- DECLARAÇÃO DE VARIAVEIS ------------------------
  // ========================================================================

  public parametros: { session?: any, filtros?: any } = {};
  public listFormatos = ['xlsx'];
  public inicio: Date;
  public fim: Date;
  public unidade: Unidade;
  public unidadeAutoComplete: EddyAutoComplete<Unidade>;
  protected datepipe: DatePipe;


  @Input() login: Login

  constructor(
    private unidadeService: UnidadeService,
    private planoContratacaoAnualService: PlanoContratacaoAnualService,
  ) {
    super();
  }

  // ========================================================================
  // -------------------------- MÉTODOS ABSTRAÍDOS --------------------------
  // ========================================================================

  protected afterInit(): void {
    this.datepipe = new DatePipe('pt');
    this.orientacao = "landscape";
    this.unidadeAutoComplete = new EddyAutoComplete(null, this.unidadeService,
      'id', ['codigo', 'nome'], { ppa_id: this.login?.['ppa']?.id, orgao_id: this.login.orgao.id, orderBy: 'nome' }, { number: ['codigo'], text: ['nome', 'codigo'] }
    );
    this.formato = 'xlsx'
  }

  protected tituloRelatorio(): string {
    return this.login.orgao.nome + ' - ' + this.unidade.codigo + ' ' + this.unidade.nome;
  }

  protected subTituloRelatorio(): string {
    return ''
  }

  protected obterColunasRelatorio(): Coluna[] {
    const retorno: Coluna[] = []
    retorno.push({ titulo: 'Item', coluna: 'item', })
    retorno.push({ titulo: 'Sub elemento', coluna: 'subelemento', })
    retorno.push({ titulo: 'Produto/Serviço', coluna: 'produto', })
    retorno.push({ titulo: 'Unidade', coluna: 'unidade', })
    retorno.push({ titulo: 'Qtde. Consumida', coluna: 'qtde_consumida', decimais: 4, alignment: 'right' })
    retorno.push({ titulo: 'Vl. Unit. Consumido', coluna: 'vl_unit_consumida', decimais: 4, alignment: 'right' })
    retorno.push({ titulo: 'Qtde. Prevista', coluna: 'qtde_prevista', decimais: 4, alignment: 'right' })
    retorno.push({ titulo: 'Vl. Unit. Previsto', coluna: 'vl_unit_prevista', decimais: 4, alignment: 'right' })
    retorno.push({ titulo: 'Diferença', coluna: 'diferenca', decimais: 4, alignment: 'right' })
    return retorno
  }

  protected larguraColunas(): (string | number)[] {
    return ['auto', '*', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto']
  }

  protected totalizarColunas(): (string | {})[] {
    return ['qtde_consumida', 'vl_unit_consumida', 'qtde_prevista', 'vl_unit_prevista']
  }

  protected async carregarLista(): Promise<any[]> {
    if (!this.inicio || !this.fim) {
      toastr.warning('Preencha os campos Período para prosseguir!')
      return;
    }

    const inicio = new Date(this.inicio);
    const fim = new Date(this.fim);

    if (inicio > fim) {
      toastr.warning('A data de início não pode ser maior que a data de fim.');
      return;
    }

    if (!this.unidade) {
      toastr.warning('Preencha o campo Unidade Administrativa para prosseguir!')
      return;
    }
    let mesInicial = this.funcaoService.converteDataSQL(this.inicio)
    let mesFinal = this.funcaoService.converteDataSQL(new Date(this.fim.getFullYear(), this.fim.getMonth() + 1, 0))

    return new Promise((resolve) => {
      this.planoContratacaoAnualService.comparativoPCA(this.login.orgao.id, this.login.exercicio.id, mesInicial, mesFinal, this.unidade.id).pipe(takeUntil(this.unsubscribe)).subscribe(async (res) => {
        if (!res) {
          toastr.info('Não foram encontrados registros')
          return;
        }
        res = res.sort((a, b) => { return +a.item - +b.item })
        resolve(res)
      }, (error) => {
        toastr.error(error.error?.payload || error.message)
        return;
      });
    });
  }

  // ========================================================================
  // -------------------------- MÉTODOS DA CLASSE ---------------------------
  // ========================================================================

}